import {AuthenticationActions, EAuthenticationActions} from "../../actions/security/authentication.actions";
import {IAuthenticationState, initialAuthenticationState} from "../../state/security/authentication.state";
import {emptyAuthentication} from "../../models/security/authentication.interface";

export const authenticationReducers = (
  state = initialAuthenticationState,
  action: AuthenticationActions
): IAuthenticationState => {
  switch (action.type) {
    case EAuthenticationActions.SetToken: {
      return {
        ...state,
        data:{
          ...state.data,
          accessToken: action.payload,
          isAuthenticated : true,
          oidcAccessToken: state.data.oidcAccessToken,
          isGoogleSignedIn: state.data.isGoogleSignedIn,
          oidcProviderType: state.data.oidcProviderType,
          authenticationInProgress: false

        }
      };
    }
    case EAuthenticationActions.SetTokenSuccess:{
      return {
        ...state
      };
    }
    case EAuthenticationActions.DestroyToken:{
      return {
        ...state,
        data:initialAuthenticationState.data
      };
    }
    case EAuthenticationActions.Authenticate: {
      return {
        ...state,
        data: {
          ...emptyAuthentication,
          isAuthenticated: false,
          oidcProviderType: 'unknown',
          oidcAccessToken: '',
          accessToken: '',
          isGoogleSignedIn: false,
          authenticationInProgress: true,
          login: action.payload.login,
          password: action.payload.password
        }
      };
    }
    case EAuthenticationActions.AuthenticateByOidc: {
      return {
        ...state,
        data: {
          ...state.data,
          isAuthenticated: false,
          oidcProviderType: action.payload.oidcProviderType,
          oidcAccessToken: action.payload.oidcToken,
          accessToken: '',
          isGoogleSignedIn: false,
          authenticationInProgress: true
        }
      };
    }
    case EAuthenticationActions.AuthenticationSuccess: {
      return {
        ...state,
        data: {
          ...state.data,
          isAuthenticated: true,
          oidcProviderType: state.data.oidcProviderType,
          oidcAccessToken: state.data.oidcAccessToken,
          accessToken: action.payload.accessToken,
          isGoogleSignedIn: !!state.data.oidcAccessToken,
          authenticationInProgress: false,
          workflowToken: action.payload.workflowToken
        }
      };
    }
    case EAuthenticationActions.AuthenticationFailure:{
      return {
        ...state,
        data:initialAuthenticationState.data
      };
    }
    case EAuthenticationActions.ClearAuthStore:{
      return {
        ...state,
        data:initialAuthenticationState.data
      };

    }


    case EAuthenticationActions.AuthenticateByAccessToken:{
      return {
        ...state,
        data:{
          ...initialAuthenticationState.data,
          accessToken: action.payload.accessToken,
          authenticationInProgress: true
        }
      };
    }

    case EAuthenticationActions.AuthenticationWorkflowSuccess: {
      return {
        ...state,
        data: {
          ...state.data,
          workflowToken: action.payload.ssoToken

        }
      };
    }
    case EAuthenticationActions.AuthenticationWorkflowFailure: {
      return {
        ...state,
        data: {
          ...state.data,
          workflowToken: ''
        }
      };
    }
    case EAuthenticationActions.ClearLoginPassword: {
      return {
        ...state,
        data: {
          ...state.data,
          login: '',
          password: ''
        }
      };
    }

    default:
      return state;
  }
};
